export default function mapFormToRequest(rooms) {
  const requestBody = { rooms: {} }
  rooms.map(room => (requestBody.rooms[room['id']] = room.position))
  return requestBody
}
